// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6402d0cb","787":"3ce4cc4d","925":"c0491a91"}[chunkId] + ".chunk.js";
};